/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Signindescription2Inputs */

const zh_learn_signindescription2 = /** @type {(inputs: Learn_Signindescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该分享内容需要先登录后才能校验访问权限。`)
};

const en_learn_signindescription2 = /** @type {(inputs: Learn_Signindescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This shared session requires you to sign in before access can be checked.`)
};

const es_learn_signindescription2 = /** @type {(inputs: Learn_Signindescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta sesión compartida requiere que inicies sesión antes de verificar el acceso.`)
};

/**
* | output |
* | --- |
* | "This shared session requires you to sign in before access can be checked." |
*
* @param {Learn_Signindescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_signindescription2 = /** @type {((inputs?: Learn_Signindescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Signindescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_signindescription2(inputs)
	if (locale === "en") return en_learn_signindescription2(inputs)
	return es_learn_signindescription2(inputs)
});
export { learn_signindescription2 as "learn_signInDescription" }